export default "__VITE_ASSET__2da4149c__"